import { types, actions } from './requests'
export const CREATECLIENTORDER_TYPES = {
    ...types('CREATECLIENTORDER'),
}
export const CREATECLIENTORDER_ACTIONS = {
    ...actions('CREATECLIENTORDER'),
}
